import React, { useState, useEffect } from 'react'
import translator from 'src/translate'
import styles from './styles'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { TabContext, TabPanel } from '@material-ui/lab'
import { domainListAction } from 'src/reducers/domain/action'
import { AssignmentFieldNames } from 'src/model/assignment'
import { Icon } from '@iconify/react'
import {
  Card,
  Typography,
  withStyles,
  Grid,
  Switch,
  FormControlLabel,
  FormControl,
  Select,
  MenuItem,
  Input,
  Divider,
} from '@material-ui/core'
import { track } from '@amplitude/analytics-browser'
import { CoreButton, CoreTextField } from 'src/components/core'

const DEFAULT_SHARE_URL = process.env.REACT_APP_VIEW_URL?.replace(/\/$/, '') || 'https://share.minicoursegenerator.com'
const DEFAULT_SHARE_DOMAIN = process.env.REACT_APP_VIEW_URL?.replace(/^https?:\/\//, '').replace(/\/$/, '') || 'share.minicoursegenerator.com'

const ShareLinkStep = props => {
  const { dispatch, classes, entity } = props
  const [showShareButtons, setShowShareButtons] = useState(0)
  const [domains, setDomains] = useState()
  const [domainName, setDomainName] = useState()
  const [copyClicked, setCopyClicked] = useState(false)

  const onClickCopy = () => {
    setCopyClicked(true)

    setTimeout(() => {
      setCopyClicked(false)
    }, 1000)
  }
  useEffect(() => {
    const query = {
      CurrentPage: 0,
      // Every domain of the workspace, not just the latest five: the picker lists them all.
      PageSize: 200,
      SortingColumn: 'LastModifiedAt',
      Asc: false,
      FilterText: '',
      Filters: [],
    }
    track('Course_Share', {
      type: 'Link',
    })
    dispatch(
      domainListAction({ ...query, SortingColumn: 'LastModifiedAt' }, data => {
        setDomains(data.results)
        const firstVerified = data.results.find(x => x.verificationStatus == 1)
        setDomainName(firstVerified?.domain || DEFAULT_SHARE_DOMAIN)
      }),
    )
  }, [])

  /**
   *
   * @param {*} e
   */
  const handleDomain = e => {
    setDomainName(e.target.value)
  }

  const domain = entity.customDomainDtos
    ? entity.customDomainDtos.length == 0 ||
      entity.customDomainDtos[0].verificationStatus != 1
      ? DEFAULT_SHARE_URL + '/'
      : 'https://' + entity.customDomainDtos[0].domain + '/'
    : DEFAULT_SHARE_URL + '/'

  let shareCode = showShareButtons ? '?shr=1' : ''

  const hasVerifiedCourse =
    domains && domains.find(x => x.verificationStatus == 1)
  return entity ? (
    <Card className={classes.settingsContainer}>
      <div>
        <TabContext>
          <TabPanel>
            {hasVerifiedCourse && (
              <div>
                <FormControl
                  style={{ width: '300px' }}
                  variant="outlined"
                  className={classes.listGroup}
                >
                  <Select
                    className={classes.select}
                    inputProps={{
                      className: classes.inputField,
                    }}
                    fullWidth
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    label="Choose your domain"
                    value={domainName}
                    key={domainName}
                    disabled={false}
                    input={<Input id="select-input" name="select-input" />}
                    onChange={handleDomain}
                  >
                    <MenuItem value={DEFAULT_SHARE_DOMAIN}>
                      {DEFAULT_SHARE_DOMAIN}
                    </MenuItem>
                    {domains &&
                      domains
                        .filter(x => x.verificationStatus == 1)
                        .map(value => {
                          return (
                            <MenuItem value={value.domain} key={value.domain}>
                              {value.domain}
                            </MenuItem>
                          )
                        })}
                  </Select>
                </FormControl>
              </div>
            )}

            <div className={classes.textFields}>
              <Grid container spacing={2}>
                <Grid
                  style={{ display: 'flex', flexDirection: 'column' }}
                  item
                  xs={12}
                  md={12}
                >
                  <CoreTextField
                    fullWidth
                    value={
                      hasVerifiedCourse
                        ? 'https://' +
                        domainName +
                        '/' +
                        entity[AssignmentFieldNames.CODE] +
                        shareCode
                        : domain + entity[AssignmentFieldNames.CODE] + shareCode
                    }
                  />

                  <CopyToClipboard
                    text={
                      hasVerifiedCourse
                        ? 'https://' +
                        domainName +
                        '/' +
                        entity[AssignmentFieldNames.CODE] +
                        shareCode
                        : domain + entity[AssignmentFieldNames.CODE] + shareCode
                    }
                    className={classes.copy}
                  >
                    <CoreButton
                      color="primary"
                      variant="outlined"
                      size="medium"
                      fullWidth={false}
                      onClick={onClickCopy}
                      style={{
                        width: '160px',
                      }}
                    >
                      {copyClicked ? 'Copied!' : 'Copy to Clipboard'}
                    </CoreButton>
                  </CopyToClipboard>
                  <div style={{ flexGrow: 1 }}></div>
                  <Divider />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginTop: '15px',
                    }}
                  >
                    <Typography>
                      Want to customize the domain of the links?{' '}
                    </Typography>
                    <a href="/workspace/custom-domain" style={{ color: '#015FFB' }}>
                      <Icon icon="ph:link-bold" color="#015FFB" />
                      Add custom domain
                    </a>
                  </div>
                </Grid>
              </Grid>
            </div>
          </TabPanel>
        </TabContext>
      </div>
    </Card>
  ) : null
}

export default withStyles(styles)(ShareLinkStep)
